import __base_store from '@/store/__base_store'

/**
 * Store de unidades de frecuencia.
 */
export default __base_store({
	state: {
		model_name: 'unidad_frecuencia',
	},
})

